import { FC, useRef } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { defaultEMSNSearchForm, EMSNSearchForm, EMSNSortForm } from 'models/eMSN'
import {
  EMSNSearch,
  EMSNSearchAlert,
  EMSNSort
} from '..'

export interface EMSNSearchAndSortProps {
  handleSearchSubmit: SubmitHandler<EMSNSearchForm>
  handleSortSubmit: SubmitHandler<EMSNSortForm>
  displaySearch: boolean
}

export const EMSNSearchAndSort: FC<EMSNSearchAndSortProps> = (
  {
    handleSearchSubmit,
    handleSortSubmit,
    displaySearch
  }
) => {
  const searchFormMethods = useForm<EMSNSearchForm>({
    mode: 'onTouched',
    reValidateMode: 'onChange',
    defaultValues: defaultEMSNSearchForm,
    shouldFocusError: false
  })

  const searchFormClaimNumberError = searchFormMethods.formState.errors.claimNumber
  const searchFormSubmitted = searchFormMethods.formState.isSubmitted

  const searchFormErrorAlertRef = useRef<HTMLDivElement>(null)

  return (
    <div className='my-u-pb--28'>
      <div tabIndex={-1} ref={searchFormErrorAlertRef}>
        {searchFormSubmitted && searchFormClaimNumberError?.message && (
          <EMSNSearchAlert claimNumberError={searchFormClaimNumberError.message} />
        )}
      </div>
      <EMSNSort
        handleSubmit={handleSortSubmit}
      />
      {displaySearch && (
        <EMSNSearch
          formMethods={searchFormMethods}
          handleSubmit={handleSearchSubmit}
          formErrorAlertWrapper={searchFormErrorAlertRef}
        />
      )}
    </div>
  )
}
